import styled, { css } from 'styled-components'
import { stoColor, stoMedia, stoSpace, stoType } from 'constants/stoTheme'

const MOTION = '300ms cubic-bezier(0.4, 0, 0.2, 1)'

/** Figma 4914:81574: white bar, 20px top and bottom, 64px sides, rule below. Desktop only; mobile has the bottom bar. */
export const Bar = styled.div<{ $visible: boolean }>`
  display: none;

  ${stoMedia.desktopUp} {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    /* Under the library modals (1000) the eligibility action opens. */
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${stoSpace[6]};
    padding: ${stoSpace[5]} ${stoSpace[16]};
    overflow: hidden;
    background: ${stoColor.surface};
    border-bottom: 1px solid ${stoColor.borderSubtle};
    transform: translateY(${({ $visible }) => ($visible ? '0' : '-100%')});
    visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
    transition:
      transform ${MOTION},
      visibility 0s ${({ $visible }) => ($visible ? '0s' : '300ms')};

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }
`

export const Identity = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
`

/** One line, measured for overflow; `$wrap` (the last step) allows two, cut after that. */
export const Title = styled.p<{ $wrap: boolean }>`
  ${stoType.headingMd};
  font-size: 20px;
  min-width: 0;
  margin: 0;
  overflow: hidden;
  color: ${stoColor.textPrimary};

  ${({ $wrap }) =>
    $wrap
      ? css`
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        `
      : css`
          white-space: nowrap;
        `}
`

export const Description = styled.p`
  ${stoType.bodyMdRegular};
  margin: 0;
  overflow: hidden;
  color: ${stoColor.textPrimary};
  text-overflow: ellipsis;
  white-space: nowrap;
`
